(function () {
  function openModal(modal) {
    if (!modal) return;
    modal.hidden = false;
    document.body.classList.add('tg-collab-modal-open');
    var closeBtn = modal.querySelector('[data-tg-collab-close]');
    if (closeBtn) closeBtn.focus();
  }

  function closeModal(modal) {
    if (!modal) return;
    modal.hidden = true;
    document.body.classList.remove('tg-collab-modal-open');
  }

  function initHero(root) {
    if (!root || root.dataset.tgCollabInit === '1') return;
    root.dataset.tgCollabInit = '1';

    var triggers = root.querySelectorAll('[data-tg-collab-open]');
    triggers.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var id = btn.getAttribute('data-tg-collab-open');
        var modal = document.getElementById(id);
        openModal(modal);
      });
    });

    var modals = root.querySelectorAll('[data-tg-collab-modal]');
    modals.forEach(function (modal) {
      modal.querySelectorAll('[data-tg-collab-close]').forEach(function (closer) {
        closer.addEventListener('click', function () {
          closeModal(modal);
        });
      });
    });
  }

  function initAll() {
    document.querySelectorAll('[data-tg-collab-hero]').forEach(initHero);
  }

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('[data-tg-collab-modal]').forEach(function (m) {
      if (!m.hidden) closeModal(m);
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-tg-collab-hero]');
    if (root) initHero(root);
  });
})();
